<template>
    <span class="rectangular-element new">
        <div class="flex-column hidden-mobile">
            <h3>{{title}}</h3>
            <v-btn :to="link" icon class="add-button">
                <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
        </div>
        <router-link :to="link" class="text-decoration-none hidden-desktop">
            <v-icon color="white">mdi-plus</v-icon>
            <h3>{{title}}</h3>
        </router-link>
    </span>
</template>

<script>
    export default {
        name: 'RectangularElementNew',
        props: ['title', 'link'],
        data: () => ({
        })
    }
</script>